import React, { useMemo } from 'react';
import { CardHcdAvailabilityOutputDTO } from '@maiia/model/generated/model/api-patient/api-patient';
import { cn } from '@kiiwi/ui';
import { Avatar } from '@/components/ui/not-existing-kiiwi-components/Avatar';
import ProCardTLCIcon from '@/components/organisms/ProCard/ProCardTLCIcon';

interface ProCardAvatarProps {
  item: CardHcdAvailabilityOutputDTO;
  className?: string;
  size?: 'xs' | 'sm';
  onClick?: React.ReactEventHandler;
}

const ProCardAvatar = ({
  item,
  className,
  size = 'sm',
  onClick,
}: ProCardAvatarProps) => {
  const { type, immediateTlc = false, avatarPicture: { s3Id } = {} } = item;

  const src = useMemo(() => {
    if (s3Id) return `/files/${s3Id}`;
    if (type === 'CENTER') return '/static/images/default_center.svg';
    return `/static/images/default_practitioner.svg`;
  }, [s3Id, type]);

  return (
    <div className={cn('relative h-max', className)}>
      <Avatar
        src={src}
        className={cn(
          onClick && 'cursor-pointer',
          size === 'xs' && 'h-[40px] w-[40px]',
          size === 'sm' && 'h-[72px] w-[72px]',
        )}
        onClick={onClick}
      />

      {immediateTlc && (
        <ProCardTLCIcon
          className={cn(
            'absolute',
            size === 'xs' && '-bottom-1 -right-1',
            size === 'sm' && 'bottom-0 right-0',
          )}
        />
      )}
    </div>
  );
};

export default ProCardAvatar;
